import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Reason } from 'src/app/shared/models/users/reason';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
})
export class CheckListComponent implements OnInit {
  @Input() CheckListItems: Reason[];
  @Input() Title: string = 'Check List';
  @Input() InstructionText: string | null;
  @Output() allChecked = new EventEmitter<void>();
  @Output() notAllChecked = new EventEmitter<void>();
  unCheckedCount: number = 0;
  constructor() {}

  ngOnInit(): void {
    this.requiresAcknowledgement();
    this.areAllChecked();
  }

  areAllChecked() {
    this.unCheckedCount = this.CheckListItems.filter(
      (item) => !item.acknowledged
    ).length;

    if (this.unCheckedCount === 0) {
      this.allChecked.emit();
    } else {
      this.notAllChecked.emit();
    }
  }

  onChanged() {
    this.areAllChecked();
  }

  requiresAcknowledgement() {
    this.CheckListItems.forEach((reason) => {
      reason.acknowledged = !reason.requiresAknowledgement;
    });
  }
}
